// Invoice Details (owner, 2026-10-11): on the Company Details page, below the details. Whether the client is
// charged for this affidavit; if so the invoice is created in TC Auditors' Xero while the affidavit is sent
// (backend xero.py raise_invoice): saved as a draft, approved, or approved and sent (email / WhatsApp / both).

export const ACTION_OPTIONS = [
  { value: "draft", label: "Draft and save" },
  { value: "approve", label: "Draft and approve" },
  { value: "send", label: "Draft, approve and send" },
];

export const DELIVERY_OPTIONS = [
  { value: "email", label: "Email only" },
  { value: "whatsapp", label: "WhatsApp only" },
  { value: "both", label: "Email and WhatsApp" },
];

// charge: null (not answered) / true / false. ready: Xero's check for this user (null until Yes is ticked).
// customer / gaveUp: typed in by hand - the client's Xero contact found by Find Customer in Xero (forName:
// the Enterprise Name it was found for), or the message why it will be invoiced by hand.
export const emptyInvoice = () => ({
  charge: null, action: "", delivery: "", ready: null, customer: null, gaveUp: "", forName: "",
});

// The same as the backend's name_key: spaces, case and punctuation ignored
export const nameKey = (name) => (name || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

export const invoiceAnswered = (inv) =>
  inv.charge === false ||
  (inv.charge === true && !!inv.action && (inv.action !== "send" || !!inv.delivery) && inv.ready?.ready === true);

// Typed in by hand: Find Customer in Xero must have found (and the user confirmed) the contact, or given up
export const customerSettled = (inv, enterpriseName) =>
  inv.forName === nameKey(enterpriseName) && (!!inv.customer || !!inv.gaveUp);

export const invoiceComplete = (inv, method, enterpriseName) => {
  if (inv.charge === false) return true;
  if (!invoiceAnswered(inv)) return false;
  return method === "xero" || customerSettled(inv, enterpriseName);
};

// For the affidavit page (sent with the affidavit; contact_name only for showing)
export const invoicePayload = (inv, method, xeroContact) => {
  if (inv.charge !== true) return { charge: false };
  const contact = method === "xero" ? xeroContact : inv.gaveUp ? null : inv.customer;
  return {
    charge: true,
    action: inv.action,
    delivery: inv.action === "send" ? inv.delivery : "",
    contact_id: contact?.id || "",
    contact_name: contact?.name || "",
  };
};

// One per affidavit page: the backend creates one invoice per id, however often Send is tried
export const newRequestId = () =>
  window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = Math.floor(Math.random() * 16);
      return (c === "x" ? r : (r % 4) + 8).toString(16);
    });

const SENT_BY = { email: "by email", whatsapp: "by WhatsApp", both: "by email and WhatsApp" };

// The affidavit page's company bar, one row each (owner, 2026-10-11): [label, value] -
// "Invoice to:" the contact, "Invoice type:" saved as a draft / approved / approved and sent by ...
export const invoiceRows = (p) => {
  if (!p?.charge) return [["Invoice:", "No invoice"]];
  if (!p.contact_id) return [["Invoice:", "to be created manually in Xero"]];
  const how = p.action === "draft" ? "saved as a draft" : p.action === "approve" ? "approved" : `approved and sent ${SENT_BY[p.delivery]}`;
  return [["Invoice to:", p.contact_name], ["Invoice type:", how]];
};
